import request from '@/utils/request'
import utils from '@/utils/common'

export function login(query) {
  return request({
    url: 'api/login',
    method: 'post',
    data: query
  })
}

export function logout(query) {
  return request({
    url: 'api/logout',
    method: 'post',
    data: query
  })
}

export function postlogin(query) {

  let userinfo = utils.storageGet("userinfo");

  if (userinfo) {
    query.studentid = userinfo.userid;
    query.flag = userinfo.heartflag;
    return request({
      url: 'api/heartlog',
      method: 'post',
      data: query
    })
  }
}

export function getTaskForStuid(query) {
  return request({
    url: 'api/task/gettaskbystuid',
    method: 'get',
    params: query
  })
}

export function getjifen(query){
  return request({
    url: 'api/getjifen',
    method: 'get',
    params: query
  })
}

export function getWodejifen(query){
  return request({
    url: 'api/getmyjifen',
    method: 'get',
    params: query
  })
}


//dictationtools
export function getbooksinfo(query){
  return request({
    url:'api/dictationtools/getbooksinfo',
    method:'get',
    params:query
  })
}
export function getunitsinfo(query){
  return request({
    url:'api/dictationtools/getunitsinfo',
    method:'get',
    params:query
  })
}
export function getwordsinfo(query){
  return request({
    url:'api/dictationtools/getwordsinfo',
    method:'get',
    params:query
  })
}
//获取音频
export function getspeehbytxt(query){
  return request({
    url:'https://sys.cizhuangyuan.com/tts/api/tts/getspeehbytxt',
    method:'post',
    data:query
  })
}
